import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Employee} from 'resteasytox';
import {CookieService} from 'ngx-cookie';
import {ApiService} from 'app/api/api.service';
import {orderBy, filter, map} from 'lodash';

export interface EmployeeFilterState {
	employees: number[];
}

@Component({
	selector: 'tt-employee-filter',
	templateUrl: 'employee-filter.component.html',
	styleUrls: ['employee-filter.component.scss']
})
export class EmployeeFilterComponent implements OnInit {
	@Input('admin') admin: boolean;
	@Input('autoApply') autoApply: boolean;
	@Input('employees') employees: Employee[];
	@Input('stateCookieName') stateCookieName: string;
	@Output('filterChanged') filterChanged: EventEmitter<number[]> = new EventEmitter<number[]>();
	@Output('filterInited') filterInited: EventEmitter<void> = new EventEmitter<void>();

	private _includeDisabled: boolean;
	private allEmployees: Employee[] = [];

	get includeDisabled(): boolean {
		return this._includeDisabled;
	}
	@Input('includeDisabled')
	set includeDisabled(value: boolean) {
		this._includeDisabled = value;
		if (this.allEmployees.length > 0) {
			this.employees = this.filterEmployees(this.allEmployees, this.includeDisabled);
		}
	}

	public selectedEmployees: number[] = [];

	constructor (
		private cookieService: CookieService,
		private apiService: ApiService
	) {
	}

	ngOnInit(): void {
		if (!this.employees || this.employees.length === 0) {
			this.apiService.getAllEmployees({params: {includeDisabled: true}})
				.take(1)
				.subscribe((employees: Employee[]) => {
					this.allEmployees = orderBy(employees, ['firstName']);
					this.employees = this.filterEmployees(this.allEmployees, this.includeDisabled);
					this.filterInited.emit();
				});
		}

		if (this.admin && this.stateCookieName && this.cookieService.get(this.stateCookieName)) {
			const state: EmployeeFilterState = this.cookieService.getObject(this.stateCookieName) as EmployeeFilterState;
			if (state && state.employees) {
				this.selectedEmployees = state.employees;
			}
			this.filterInited.emit();
		}

		if (this.employees) {
			this.filterInited.emit();
		}
	}

	public toggleEmployee(employeeId: number): void {
		if (this.selectedEmployees.indexOf(employeeId) !== -1 ) {
			const index: number = this.selectedEmployees.indexOf(employeeId);
			this.selectedEmployees.splice(index, 1);
		} else {
			this.selectedEmployees.push(employeeId);
		}

		if (this.autoApply) {
			this.applyFilter();
		}
	}

	public isSelected(employeeId: number): boolean {
		return (this.selectedEmployees.indexOf(employeeId) !== -1);
	}

	public resetFilter(): void {
		this.selectedEmployees = [];
	}

	public applyFilter(): void {
		this.saveCurrentState();
		this.filterChanged.emit(this.selectedEmployees);
	}

	public getSelectedEmployeesIds(): number[] {
		return this.selectedEmployees;
	}

	public getDisplayedEmployeesIds(): number[] {
		return map(this.employees, (employee: Employee) => {return employee.id; });
	}

	private saveCurrentState(): void {
		if (this.stateCookieName) {
			this.cookieService.putObject(this.stateCookieName, {employees: this.selectedEmployees}, {
				expires: new Date(Date.now() + 90 * 24 * 60 * 60 * 1000)
			});
		}
	}

	private filterEmployees(employees: Employee[], includeDisabled: boolean): Employee[] {
		if (includeDisabled) {
			return employees;
		} else {
			return filter(employees, { disabled: false});
		}
	}

}



// WEBPACK FOOTER //
// ./src/app/shared/employee-filter/employee-filter.component.ts